import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminPharmaciesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/pharmacies',
  validateSearch: z.object({
    tab: z
      .enum([
        'all',
        'awaiting_verification',
        'awaiting_onboarding',
        'verified',
        'no_invoice',
        'old_invoice',
      ])
      .default('all'),
    page: zodPage,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/Pharmacies/AdminPharmaciesPage/AdminPharmaciesPage').then((d) => d.Route)
);
